// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Button_buttonContainer__X5AJ-","secondaryButton":"Button_secondaryButton__vvOGb"};